import { resetPasswordStyles } from "@insite/content-library/Widgets/ResetPassword/ResetPassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

resetPasswordStyles.submitButton = {
    css: css`
        border-radius: 25px;
        border: 1px solid ${getColor("warning")};
        background-color: ${getColor("warning")};
        > span {
            color: ${getColor("info.contrast")} !important;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
        }
        &:hover {
            border: 1px solid ${getColor("warning.contrast")};
            background-color: ${getColor("warning.contrast")};
        }
    `,
};

resetPasswordStyles.passwordGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

resetPasswordStyles.requirementsGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

resetPasswordStyles.requirementsTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        color: ${getColor("secondary")};
        font-weight: ${TYPOGRAPHY.weight.baseBold};
        margin-bottom: 7px;
    `,
};

resetPasswordStyles.passwordGridContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        max-width: 300px;
                        margin: 0;
                    `,
                ],
                "min",
            )}
    `,
};
